import { WebLogo, WebLogoAr } from "@/assets";
import Link from "next/link";
function BasicHeader({
  isArabic
}) {
  return <header style={{
    position: "sticky",
    top: 0,
    zIndex: 50,
    maxHeight: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    paddingTop: "0.75rem",
    paddingBottom: "0.75rem",
    textAlign: "center",
    width: "100%",
    backgroundColor: "rgba(27, 27, 27, 1)",
    margin: "0 auto",
    height: "fit-content"
  }} data-sentry-component="BasicHeader" data-sentry-source-file="BasicHeader.jsx">
      <div style={{
      pointerEvents: "auto",
      width: "100%",
      margin: "auto",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center"
    }}>
        <div style={{
        display: "flex",
        margin: "auto",
        color: "#fff",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        width: "119px",
        height: "44px",
        transform: `translateX(${isArabic ? "0px" : "-15px"})`
      }}>
          <Link title={"AlHome logo"} href="/" aria-label="alhome" data-sentry-element="Link" data-sentry-source-file="BasicHeader.jsx">
            {isArabic ? <WebLogoAr style={{
            width: "100%"
          }} /> : <WebLogo style={{
            width: "100%"
          }} />}
          </Link>
        </div>
      </div>
    </header>;
}
export default BasicHeader;